import { jsx } from 'panel';
import { delayedAttrRemove } from 'panel/build/component-utils/hook-helpers';
import { ButtonEl } from 'common/components/button';
import { SvgIconEl } from 'common/components/svg-icon';
import { DropMenuEl } from 'common/components/drop-menu';
import { ItemsMenuEl } from 'common/components/items-menu';
import { TooltipEl } from 'common/components/tooltip';
import { ContextPanelEl } from 'common/widgets/context-panel';
import { InputEl } from 'common/components/input';

function BlockSelectorEl() {
  var _a;

  const {
    isMenuOpen
  } = this.state;
  const selectorTheme = this.helpers.getSelectorTheme();
  const removeButonEl = this.attr("removable") && jsx("div", {
    sel: '.mp-query-block-remove-button',
    on: {
      click: this.helpers.handleRemove
    }
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "circle-clear"
    }
  }));
  const blockSelectorLabel = this.helpers.showInput() ? this.helpers.selectedLabel() || this.attr("label") : this.attr("label");
  const blockSelectorIcon = (_a = this.attr("selector-icon")) !== null && _a !== void 0 ? _a : this.helpers.selectedIcon();

  if (this.attr("selector-type") === "button" || this.attr("theme") === "select") {
    return jsx(ButtonEl, {
      sel: '.truncated',
      key: JSON.stringify(this.attr("selected")) + blockSelectorLabel,
      attrs: {
        disabled: this.attr("disabled"),
        icon: blockSelectorIcon || "",
        theme: selectorTheme,
        pressed: isMenuOpen,
        readonly: this.attr("readonly")
      },
      hook: {
        insert: _ref => {
          let {
            elm
          } = _ref;
          return this.helpers.onAutofocusableElAdded(elm);
        }
      }
    }, jsx("span", {
      attrs: {
        elref: "blockMenuLabel"
      }
    }, jsx("span", {
      sel: '.label-prefix'
    }, !this.attr("hide-prefix-label") && this.attr("prefix-label")), blockSelectorLabel, removeButonEl));
  } else {
    // block label
    return jsx("div", {
      sel: '.mp-query-menu-label',
      class: {
        'is-disabled': this.attr("disabled"),
        'is-editing': this.helpers.showInput() && isMenuOpen,
        ["is-theme-".concat(selectorTheme)]: true
      },
      attrs: {
        elref: "blockMenuLabel"
      }
    }, blockSelectorIcon && jsx(SvgIconEl, {
      attrs: {
        icon: blockSelectorIcon
      }
    }), blockSelectorLabel, removeButonEl);
  }
}

function SearchWrapperEl() {
  return jsx("div", {
    sel: '.search-wrapper'
  }, jsx(InputEl, {
    attrs: {
      icon: "search",
      placeholder: this.attr("search-placeholder") || "Search",
      elref: "searchInput"
    },
    props: {
      value: this.state.searchFilter
    },
    on: {
      input: this.helpers.handleSearchInput,
      clear: this.helpers.handleSearchInput
    },
    hook: {
      insert: this.helpers.searchInputInserted
    }
  }));
}

export function template() {
  const {
    getSortedMenuSections,
    isHeaderMenuOpen,
    isMenuOpen,
    openModal,
    tooltipData
  } = this.state;
  const selectorType = this.attr("selector-type"); // When this.attr(`input-only`) is set, the query block has a static label

  const selectorTheme = this.helpers.getSelectorTheme();
  const prefixLabel = !this.attr("hide-prefix-label") && (this.attr("prefix-label") || this.helpers.getPrefixLabel());
  const headerSegments = this.helpers.getHeaderSegments();
  const tooltipAttrs = this.attr("tooltip");
  return jsx("div", {
    sel: '.mp-query-block',
    class: {
      'has-prefix-label': prefixLabel,
      'has-header-segments': headerSegments.length,
      ["mp-query-theme-".concat(selectorTheme)]: true
    }
  }, jsx("div", {
    sel: '.mp-query-block-header-container'
  }, headerSegments.map(segment => segment.type === "text" ? jsx("div", {
    sel: '.mp-query-block-header-segment-label'
  }, segment.value) : segment.type === "select" ? jsx(null, null, jsx("div", {
    sel: '.mp-query-block-header-drop-menu'
  }, jsx(DropMenuEl, {
    attrs: {
      open: isHeaderMenuOpen
    },
    on: {
      change: this.helpers.handleHeaderMenuVisibilityChange
    }
  }, jsx(ItemsMenuEl, {
    attrs: {
      sections: this.helpers.getHeaderMenuSection(segment)
    },
    on: {
      clickItem: this.helpers.handleHeaderSelectionChanged
    }
  }))), jsx("div", {
    sel: '.mp-query-block-header-segment-selector-label',
    on: {
      click: this.helpers.handleHeaderSelectClicked
    }
  }, segment.selectedItem.label, jsx(SvgIconEl, {
    attrs: {
      icon: "caret-down"
    }
  }))) : null), this.attr("help-text") ? jsx("div", {
    sel: '.header-info'
  }, jsx(SvgIconEl, {
    attrs: {
      icon: "info"
    }
  }), jsx(TooltipEl, {
    sel: '.help-text'
  }, this.attr("help-text"))) : null), selectorType !== "button" && prefixLabel ? jsx("div", {
    sel: '.mp-query-block-unit',
    attrs: {
      elref: "blockUnitLabel"
    }
  }, prefixLabel) : null, jsx("div", {
    sel: '.mp-query-block-selector',
    class: {
      'mp-query-editing': this.helpers.showInput() && isMenuOpen
    },
    on: {
      click: !this.helpers.isReadOnly() && this.helpers.handleLabelClick
    },
    attrs: {
      elref: "selectorLabel"
    }
  }, tooltipData && !isMenuOpen && !openModal ? this.helpers.renderContextPanelFromMenu() ? this.helpers.renderContextPanelFromMenu() : jsx(ContextPanelEl, {
    hook: {
      remove: delayedAttrRemove("tooltip-data", null)
    },
    attrs: {
      'tooltip-data': JSON.stringify(tooltipData),
      'position-parent-selector': ".mp-query-block-selector",
      placement: "bottom"
    },
    on: {
      hoverIn: this.helpers.handleContextPanelHoverIn,
      hoverOut: this.helpers.handleContextPanelHoverOut,
      tooltipContextAction: this.helpers.handleTooltipContextAction,
      tooltipContextEditDescription: this.helpers.handlePropagatedtooltipContextEditDescription
    }
  }) : !isMenuOpen && tooltipAttrs ? jsx(TooltipEl, {
    attrs: Object.assign({
      size: "small",
      placement: "right"
    }, tooltipAttrs)
  }) : null, jsx("div", {
    sel: '.mp-query-block-selector-inner',
    attrs: {
      elref: "selectorLabelInner"
    },
    on: {
      mouseenter: this.helpers.handleLabelMouseEnter,
      mouseleave: this.helpers.handleLabelMouseLeave
    }
  }, BlockSelectorEl.call(this), this.helpers.renderSelectedDateTooltipIfNeeded()), jsx("div", {
    sel: '.mp-query-drop-menu-container',
    class: {
      ["is-".concat(this.attr("dropdown-alignment"), "-aligned")]: true
    }
  }, this.helpers.isReady() && jsx(DropMenuEl, {
    class: {
      'custom-width': this.helpers.menuHasCustomWidth()
    },
    attrs: {
      open: isMenuOpen,
      'prevent-close-selectors': ["mp-context-panel-internal"]
    },
    on: {
      change: this.helpers.handleMenuChange,
      click: ev => ev.stopPropagation()
      /* clicks in the drop menu should not bubble up */

    }
  }, this.state.childMenu.isContentSearchable() && SearchWrapperEl.call(this), this.child(this.childMenuComponentName, {
    attrs: this.helpers.getChildMenuAttributes(),
    key: this.childMenuComponentName,
    on: {
      selectAll: this.helpers.handleSelectAll,
      select: this.helpers.handleSelect,
      delete: this.helpers.handleDelete,
      cancel: this.helpers.handleCancel,
      closedModal: this.helpers.handleChildMenuClosedModal,
      tooltipContextEditDescription: this.helpers.handlePropagatedtooltipContextEditDescription
    },
    hook: {
      insert: this.helpers.menuInserted
    },
    props: {
      tooltipPositionParentElement: this.helpers.getTooltipPositionParentElement(),
      getSortedMenuSections
    }
  })))));
}